const state = {
  showSummary: false,
  navigationDrawerOpen: true,
  navigationDrawerMini: false,
  rightBarOpen: true,
  rightBarMini: false,
  tableOfContents: null
};

const getters = {
  showSummary: state => state.showSummary,
  navigationDrawerOpen: state => state.navigationDrawerOpen,
  navigationDrawerMini: state => state.navigationDrawerMini,
  rightBarOpen: state => state.rightBarOpen,
  rightBarMini: state => state.rightBarMini,
  tableOfContents: state => state.tableOfContents
};

const actions = {
  toggleSummary({
    state,
    commit
  }) {
    commit('setShowSummary', !state.showSummary);
  },
  toggleNavigationDrawerOpen({
    state,
    commit
  }) {
    commit('setNavigationDrawerOpen', !state.navigationDrawerOpen);
  },
  toggleNavigationDrawerMini({
    state,
    commit
  }) {
    commit('setNavigationDrawerMini', !state.navigationDrawerMini);
  },
  toggleRightBarOpen({
    state,
    commit
  }) {
    commit('setRightBarOpen', !state.rightBarOpen);
  },
  toggleRightBarMini({
    state,
    commit
  }) {
    commit('setRightBarMini', !state.rightBarMini);
  }
};

const mutations = {
  setShowSummary: (state, showSummary) => {
    state.showSummary = showSummary;
  },
  setNavigationDrawerOpen: (state, open) => {
    state.navigationDrawerOpen = open;
  },
  setNavigationDrawerMini: (state, mini) => {
    state.navigationDrawerMini = mini;
  },
  setRightBarOpen: (state, open) => {
    state.rightBarOpen = open;
  },
  setRightBarMini: (state, mini) => {
    state.rightBarMini = mini;
  },
  setTableOfContents: (state, toc) => {
    state.tableOfContents = toc;
  }
};

export default {
  state,
  getters,
  actions,
  mutations
}